import { ActionType } from "../action-types";
import { Action } from "../actions";
import { UnlockReasonsState } from "../../dto/unlockReasons";

const initialState: UnlockReasonsState = { reasons: [] };

const unlockReasonsReducer = (
  state: UnlockReasonsState = initialState,
  action: Action
): UnlockReasonsState => {
  switch (action.type) {
    case ActionType.SET_UNLOCK_REASONS:
      return action.payload;
    default:
      return state;
  }
};

export default unlockReasonsReducer;
